import { isOpenQuoteAndOrderCalendarModal } from "@/atoms/is-open-quote-and-order-calendar-modal";
import { ButtonColor } from "@/common/enum/button-color";
import { Button } from "flowbite-react";
import { useRecoilState } from "recoil";
import { CalendarOutlineIcon } from "../icon/CalendarOutlineIcon";
import { Body14Regular } from "../typography/Body14Regular";

export const PartnerQuoteCalendarButton = () => {
  const [modal, setModal] = useRecoilState(isOpenQuoteAndOrderCalendarModal);

  const isActive = modal.startDate && modal.endDate;

  const handleOpen = () => {
    setModal({ ...modal, open: true });
  };

  return (
    <div>
      <Button
        onClick={handleOpen}
        color={ButtonColor.WHITE}
        size="sx"
        className={`flex items-center justify-between h-[42px] px-[12px] ${
          isActive
            ? "text-semantic-success-success-primary"
            : "text-primary-black"
        }`}
      >
        <CalendarOutlineIcon size={18} className="mr-[8px] mt-[2px]" />
        <Body14Regular>
          {isActive ? "날짜 기간 설정" : "기간 설정"}
        </Body14Regular>
      </Button>
    </div>
  );
};
